module.exports = __webpack_public_path__ + "static/media/01a_IMF-1.6-C-8 1.73c964f1.svg";